<div class="container">
  <div>
      <img src="/assets/img/duck.svg" alt="иконка страница не найдена">
  </div>
  <div class="title">
      Страница не найдена!
  </div>
  <div>
      <button class="btn-main" (click)="goTo()">На главную</button>
  </div>
</div>
